export default __webpack_public_path__ + "static/media/InDel.3b518061.svg";